module.exports = __webpack_public_path__ + "img/my_mood-w.svg";